import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useAlert } from 'react-alert'
import Logo from '../../assets/images/RetinaLogo.png'
import { Container, Navbar, Nav, Badge, Row, Col, Dropdown, CardGroup, Card, Button, Tooltip, Overlay } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FaShoppingCart, FaTrash, FaTimes, FaPhoneAlt } from "react-icons/fa";
import { Scrollbars } from 'react-custom-scrollbars';
import { bucket_url, retina_student_panel_url } from '../../constants/const'
import { removeFromCart, addToCart } from '../../actions/cartActions'
import { CLEAR_MESSAGE_ERROR } from '../../actions/actionTypes'
// import './nav.css';
import navStyles from './nav.module.css';
// import { Button } from 'bootstrap';

const Navigation = props => {

    const dispatch = useDispatch()
    const alert = useAlert()
    const cartButton = useRef(null)
    const [showEmptyCart, setShowEmptyCart] = useState(null)

    const { cartItems, totalPrice, message, error } = useSelector(state => state.cart)

    const deleteItem = _id => {
        dispatch(removeFromCart(_id))
    }

    useEffect(() => {
        if (message) {
            alert.success(message)
            dispatch({ type: CLEAR_MESSAGE_ERROR })
        }
        if (error) {
            alert.error(error)
            dispatch({ type: CLEAR_MESSAGE_ERROR })
        }
    }, [message, error, dispatch, alert])

    const updateCart = (i, quantity) => {
        i.quantity = quantity
        dispatch(addToCart(i))
    }

    return (
        <header className="retina-top-header">
            <Container>
                <Row>
                    <Col>
                        <Navbar collapseOnSelect expand="lg" bg="" variant="light">
                            <LinkContainer to="/">
                                <Navbar.Brand>
                                    <img src={Logo} alt="Retina Logo" />
                                </Navbar.Brand>
                            </LinkContainer>
                            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                            <Navbar.Collapse id="responsive-navbar-nav">
                                {/* <Nav className="mr-auto">
                                    <Nav.Link href="#features">Features</Nav.Link>
                                    <Nav.Link href="#pricing">Pricing</Nav.Link>
                                    <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
                                        <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                                    </NavDropdown>
                                </Nav> */}
                                <Nav className="ml-auto">
                                    {/* <Nav.Link className="px-lg-3" styleName="navStyles.nav-link" href="/">হোম</Nav.Link>
                                    <Nav.Link className="px-lg-3" styleName="navStyles.nav-link" href="/about">আমাদের সম্পর্কে</Nav.Link> */}
                                    <LinkContainer to="/courses">
                                        <Nav.Link className="px-lg-3" styleName="navStyles.nav-link" >কোর্সসমূহ</Nav.Link>
                                    </LinkContainer>
                                    <LinkContainer to="/publications">
                                        <Nav.Link className="px-lg-3" styleName="navStyles.nav-link">পাবলিকেশন</Nav.Link>
                                    </LinkContainer>
                                    <LinkContainer to="/branches">
                                        <Nav.Link className="px-lg-3" styleName="navStyles.nav-link">শাখাসমূহ</Nav.Link>
                                    </LinkContainer>
                                    <Nav.Link href='tel:+8809677999666' className="px-lg-3" styleName="navStyles.callLink navStyles.nav-link"><FaPhoneAlt className='mr-1' /> কল করুন</Nav.Link>
                                    {/* <LinkContainer to="">
                                    </LinkContainer> */}
                                    {/* <Nav.Link className="px-lg-3" styleName="navStyles.nav-link" href="/publications">পাবলিকেশন</Nav.Link> */}
                                    {/* <Nav.Link className="px-lg-3" styleName="navStyles.nav-link" href="/medical-colleges">মেডিকেল কলেজসমূহ</Nav.Link> */}
                                    {/* <Nav.Link className="px-lg-3" styleName="navStyles.nav-link" href="/contact">যোগাযোগ</Nav.Link> */}
                                    {/* <Nav.Link className="loginLink px-lg-3" href="/contact">Contact</Nav.Link> */}
                                    <LinkContainer to="#">
                                        <Nav.Link className="loginLink px-lg-3 ml-lg-3" styleName="navStyles.loginLink navStyles.nav-link">লগ-ইন</Nav.Link>
                                    </LinkContainer>

                                    {/* <Nav.Link className="px-lg-3 ml-lg-3" styleName="navStyles.cartLink navStyles.nav-link" href="#">
                                    </Nav.Link> */}

                                    {/* <LinkContainer>
                                    </LinkContainer>
                                    <LinkContainer>
                                    </LinkContainer>
                                    <LinkContainer>
                                    </LinkContainer> */}
                                    {/* <Nav.Link eventKey={2} href="#memes">
                                        Dank memes
                                    </Nav.Link> */}
                                </Nav>
                            </Navbar.Collapse>

                            <Dropdown alignRight={true} styleName="cart-link-wrap"
                                onToggle={(isOpen) => setShowEmptyCart(isOpen)}
                            >
                                <Dropdown.Toggle ref={cartButton} id="cart-link" className="cartLink px-lg-3 ml-lg-3" styleName="navStyles.cartLink navStyles.nav-link">
                                    <FaShoppingCart />
                                    {
                                        (cartItems.length > 0) &&
                                        <Badge className='ml-2' variant="dark" styleName="navStyles.navBadge">{cartItems.length}</Badge>
                                    }
                                </Dropdown.Toggle>

                                <Dropdown.Menu styleName="navStyles.cartMenu">
                                    {
                                        (cartItems.length > 0) ?
                                            <div className="p-2" styleName="navStyles.cartMenuWrap">
                                                <ul className="cart-list p-0">
                                                    <CardGroup className="flex-row" >
                                                        <Scrollbars style={{ height: 300 }}>
                                                            {cartItems.map((item, index) => <Card key={index} className="flex-fill" styleName="cart-item">
                                                                <Row className="mx-0">
                                                                    <Col xs={2} className="px-0">
                                                                        <Card.Img styleName="cart-item-img" variant="top" src={`${bucket_url}${item.images[0]}`} />
                                                                    </Col>
                                                                    <Col xs={8} className="px-0">
                                                                        <Card.Body className="p-2">
                                                                            <Card.Title className="text-truncate" styleName="item-title">{item.title}</Card.Title>
                                                                            <div className="d-flex align-items-center flex-wrap" styleName="item-price-n-quantity">
                                                                                <div className="d-flex align-items-center">
                                                                                    <span className="flex-shrink-0 text-nowrap mr-2">
                                                                                        <span className="cart-current-price">{item.price - item.discount} টাকা</span>
                                                                                    </span>
                                                                                    <FaTimes className="flex-shrink-0 " />
                                                                                    <input type='number' className="flex-shrink-0 mx-2" value={item.quantity} min="1" onChange={(e) => updateCart(item, e.target.value)} />
                                                                                    {/* <Form.Control className="flex-shrink-0 mx-2" type="number" value={item.quantity} min="1" /> */}
                                                                                </div>
                                                                                <span className="flex-shrink-0 text-nowrap">= {(item.price - item.discount) * item.quantity} টাকা</span>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Col>
                                                                    <Col xs={2} className="px-0">
                                                                        <div className="d-flex align-items-center justify-content-center h-100">
                                                                            <Button onClick={() => deleteItem(item._id)} variant="link" className="delete-btn" styleName="delete-btn"><FaTrash /></Button>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Card>)
                                                                // : <h2 className='text-center position-absolute' style={{ top: '50%', left: '40%' }}>No Item</h2>
                                                            }
                                                        </Scrollbars>
                                                    </CardGroup>
                                                </ul>
                                                <Dropdown.Divider />
                                                <Row className="mx-0 align-items-center">
                                                    <Col xs={12} sm={4}>
                                                        <div className="d-flex flex-column">
                                                            <span><strong>Total: </strong></span>
                                                            <span>{totalPrice} টাকা</span>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} sm={8}>
                                                        <div className="d-flex justify-content-end flex-wrap">
                                                            {/* <LinkContainer to={`${retina_student_panel_url}/sign-up?enroll=${true}`}>
                                                                <Button href='aaaa' target="_blank" variant="danger" className="ml-2">Checkout</Button>
                                                            </LinkContainer> */}
                                                            <a variant="danger" target="_blank" rel='noreferrer' className="enroll-btn btn-lg btn" href={`${retina_student_panel_url}/sign-up?publication=${JSON.stringify(cartItems.map(item => ({ _id: item._id, quantity: item.quantity })))}&enroll=${true}`}>Checkout</a>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            : <Overlay target={cartButton.current} show={showEmptyCart} placement="bottom-end">
                                                {(props) => (
                                                    <Tooltip id="overlay-example" {...props}>
                                                        Empty Cart! <br />
                                                        <small>Add something into the cart!</small>
                                                    </Tooltip>
                                                )}
                                            </Overlay>

                                    }
                                    {/* <Row className="mx-0 align-items-center">
                                        <Col xs={3}>
                                            <span>Discount</span>
                                        </Col>
                                        <Col xs={4}>
                                            <div className="d-flex flex-column">
                                                { !!!hasCoupon &&
                                                    <Button
                                                        styleName="has-coupon"
                                                        onClick={() => setHasCoupon(true)}
                                                        variant="link"
                                                        className="text-nowrap p-0"
                                                        >
                                                        <small>Apply Coupon</small>
                                                    </Button>}
                                                { !!hasCoupon && <div className="coupon-form">
                                                    <Form.Control type="text" />
                                                    <div className="d-flex justify-content-lg-between">
                                                        <Button
                                                            styleName="cancel-coupon"
                                                            onClick={() => setHasCoupon(false)}
                                                            variant="link"
                                                            className="flex-shrink-0 p-0 mr-1"
                                                            >
                                                            <small>Cancel</small>
                                                        </Button>

                                                        <Button
                                                            styleName="apply-coupon"
                                                            variant="link"
                                                            className="apply-coupon flex-shrink-0 p-0"
                                                            >
                                                                <small>Apply</small>
                                                        </Button>
                                                    </div>
                                                </div>}
                                            </div>
                                        </Col>
                                        <Col xs={5}>
                                            <span>৪৮০০০ টাকা</span>
                                        </Col>
                                    </Row>
                                    <Row className="mx-0 align-items-center">
                                        <Col xs={7}>
                                            <span>Total</span>
                                        </Col>
                                        <Col xs={5}>
                                            <span>৪৮০০০ টাকা</span>
                                        </Col>
                                    </Row> */}
                                </Dropdown.Menu>
                            </Dropdown>

                        </Navbar>
                    </Col>
                </Row>
            </Container>
        </header>
    )
}

export default Navigation;